import { render, staticRenderFns } from "./FormulationApplicationPopUp.vue?vue&type=template&id=0fe77460&scoped=true&"
import script from "./FormulationApplicationPopUp.vue?vue&type=script&lang=js&"
export * from "./FormulationApplicationPopUp.vue?vue&type=script&lang=js&"
import style0 from "./FormulationApplicationPopUp.vue?vue&type=style&index=0&id=0fe77460&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe77460",
  null
  
)

export default component.exports